/* Zambia-specific data for the Crossbase SME registration form
   Source: MSME Toolkit (Ministry of SMEs) + ISIC Rev 4 (UN Stats) */

export const PROVINCES_ALPHA = [
  'Central Province',
  'Copperbelt Province',
  'Eastern Province',
  'Luapula Province',
  'Lusaka Province',
  'Muchinga Province',
  'Northern Province',
  'North-Western Province',
  'Southern Province',
  'Western Province',
];

/* 116 districts grouped by province (Ministry source) */
export const DISTRICTS_BY_PROVINCE = {
  'Central Province': ['Mumbwa', 'Shibuyunji', 'Chibombo', 'Chisamba', 'Ngabwe', 'Kabwe', 'Kapiri Mposhi', 'Mkushi', 'Luano', 'Serenje', 'Chitambo'],
  'Copperbelt Province': ['Masaiti', 'Mpongwe', 'Lufwanyama', 'Ndola', 'Luanshya', 'Kitwe', 'Kalulushi', 'Mufulira', 'Chingola', 'Chililabombwe'],
  'Eastern Province': ['Chama', 'Chasefu', 'Lundazi', 'Lumezi', 'Chipangali', 'Mambwe', 'Chipata', 'Vubwi', 'Chadiza', 'Kasenengwa', 'Katete', 'Sinda', 'Petauke', 'Lusangazi', 'Nyimba'],
  'Luapula Province': ['Chienge', 'Nchelenge', 'Kawambwa', 'Mwansabombwe', 'Mwense', 'Chipili', 'Mansa', 'Samfya', 'Chifunabuli', 'Milenge', 'Chembe', 'Lunga'],
  'Lusaka Province': ['Luangwa', 'Rufunsa', 'Chongwe', 'Lusaka', 'Chilanga', 'Kafue'],
  'Muchinga Province': ['Lavushimanda', 'Mpika', 'Kanchibiya', 'Shiwang’andu', 'Chinsali', 'Isoka', 'Mafinga', 'Nakonde'],
  'Northern Province': ['Chilubi', 'Luwingu', 'Lupososhi', 'Mporokoso', 'Lunte', 'Nsama', 'Kaputa', 'Kasama', 'Mungwi', 'Senga Hill', 'Mbala', 'Mpulungu'],
  'North-Western Province': ['Chavuma', 'Zambezi', 'Kabompo', 'Mufumbwe', 'Kasempa', 'Solwezi', 'Mushindamo', 'Kalumbila', 'Manyinga', 'Mwinilunga', 'Ikeleng’i'],
  'Southern Province': ['Chirundu', 'Siavonga', 'Chikankata', 'Mazabuka', 'Monze', 'Gwembe', 'Sinazongwe', 'Pemba', 'Choma', 'Namwala', 'Itezhi tezhi', 'Kalomo', 'Zimba', 'Livingstone', 'Kazungula'],
  'Western Province': ['Mulobezi', 'Mwandi', 'Sesheke', 'Sioma', 'Shangombo', 'Senanga', 'Nalolo', 'Mongu', 'Limulunga', 'Sikongo', 'Kalabo', 'Luampa', 'Lukulu', 'Mitete', 'Kaoma', 'Nkeyema'],
};

/* ISIC Rev 4 main sections (UN Statistics – https://unstats.un.org/unsd/classifications/Family/Detail/27) */
export const ISIC_SECTORS = [
  { code: 'A', name: 'Agriculture, forestry and fishing' },
  { code: 'B', name: 'Mining and quarrying' },
  { code: 'C', name: 'Manufacturing' },
  { code: 'D', name: 'Electricity, gas, steam and air conditioning supply' },
  { code: 'E', name: 'Water supply; sewerage, waste management' },
  { code: 'F', name: 'Construction' },
  { code: 'G', name: 'Wholesale and retail trade; repair of motor vehicles' },
  { code: 'H', name: 'Transportation and storage' },
  { code: 'I', name: 'Accommodation and food service activities' },
  { code: 'J', name: 'Information and communication' },
  { code: 'K', name: 'Financial and insurance activities' },
  { code: 'L', name: 'Real estate activities' },
  { code: 'M', name: 'Professional, scientific and technical activities' },
  { code: 'N', name: 'Administrative and support service activities' },
  { code: 'O', name: 'Public administration and defence; social security' },
  { code: 'P', name: 'Education' },
  { code: 'Q', name: 'Human health and social work activities' },
  { code: 'R', name: 'Arts, entertainment and recreation' },
  { code: 'S', name: 'Other service activities' },
  { code: 'T', name: 'Activities of households as employers' },
  { code: 'U', name: 'Activities of extraterritorial organizations and bodies' },
];

/* MSME Toolkit Annual Turnover ranges (ZMW) — column 1 & 2 of the size table */
export const TURNOVER_RANGES = [
  { value: 'micro', label: 'Micro — ZMW 0 to 1,000,000', min: 0, max: 1_000_000, category: 'Micro' },
  { value: 'small', label: 'Small — ZMW 1,000,001 to 10,000,000', min: 1_000_001, max: 10_000_000, category: 'Small' },
  { value: 'medium', label: 'Medium — ZMW 10,000,001 to 50,000,000', min: 10_000_001, max: 50_000_000, category: 'Medium' },
  { value: 'large', label: 'Large — Above ZMW 50,000,000', min: 50_000_001, max: Infinity, category: 'Large' },
];

export const LEGAL_FORMS = ['Sole Proprietor', 'Partnership', 'Limited Company'];

/* Resolve a category from a turnover range value */
export const categoryFromTurnover = (rangeValue) => {
  const r = TURNOVER_RANGES.find(x => x.value === rangeValue);
  return r ? r.category : '';
};
